'use client';

import { validateOptionalPremiseId } from '@dte/otw-azure-functions/src/common/util/validation/validatePremiseId';
import type { PropsWithChildren } from 'react';
import { useValidatedStringQueryParam } from '../../../../../hooks/parameters/useValidatedStringQueryParam';

export interface PropsWithPremiseId extends PropsWithChildren {
	premiseId?: string;
}

export function usePremiseId(premiseId?: string): string | undefined {
	const queryValue = useValidatedStringQueryParam(
		'premiseId',
		(value) => validateOptionalPremiseId(value) !== undefined,
	);

	// Check first if we had the premise id passed in as a parameter
	const premiseIdValue = validateOptionalPremiseId(premiseId);
	if (premiseIdValue) {
		return premiseIdValue;
	}

	// Fall back on looking at the URL
	return queryValue;
}
